import { css, jsx } from '@emotion/core';
import React from 'react';

import contentStyle from '@/src/cms/contentStyle';
import Heading from '@/src/shared/components/Heading';
import Sanitize from '@/src/shared/components/Sanitize';
import { bp } from '@/styles';

const styles = {
  header: css`
    @media (max-width: ${bp.sizes.md}px) {
      font-size: 2.8rem;
      margin: 1.6rem 0;
    }
  `,
};

const RegisterHero = props => {
  const { title, subtitle } = props;

  return (
    <div>
      <Heading type={1} theme="primaryGray" weight="bolder" overrideStyles={styles.header}>
        {title}
      </Heading>
      <Sanitize css={contentStyle}>{subtitle}</Sanitize>
    </div>
  );
};

RegisterHero.defaultProps = {
  title: 'Register / Update Profile',
  subtitle: '',
};

export default RegisterHero;
